var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.846,
    height: 11.538,
    viewBox: "0 0 13.846 11.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing_Page",
    "data-name": "Landing Page",
    transform: "translate(-97.998 -70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M110.921,70h-12a.926.926,0,0,0-.923.923v9.692a.926.926,0,0,0,.923.923h12a.926.926,0,0,0,.923-.923V70.923a.926.926,0,0,0-.923-.923Zm.308,1.861H98.614v-.938a.309.309,0,0,1,.308-.308h12a.309.309,0,0,1,.308.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M135.762,105.2a.246.246,0,0,1-.244-.244.244.244,0,1,1,.244.244Zm.674,0a.244.244,0,1,1,.244-.244A.238.238,0,0,1,136.436,105.2Zm.674,0a.244.244,0,1,1,.244-.244A.238.238,0,0,1,137.11,105.2Z",
    transform: "translate(-36.048 -33.815)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPage);
export default __webpack_public_path__ + "static/media/landing_page.3c530614835eb1f6b483bfa225d5e48e.svg";
export { ForwardRef as ReactComponent };